import { RequestTagMultiValuedList } from '../../../Request'
import { TAG_HEIGHT } from '../../../Tag'
import { TableCellEmpty } from '../../TableCellEmpty'
import { TableCellBase } from '../TableCellBase'

function TableServiceRequestCell({
  filter,
  items,
  listProps,
  scrollRef,
  sortMoreItems,
  ...cellProps
}) {
  return (
    <TableCellBase {...cellProps}>
      {items.length > 0 ? (
        <RequestTagMultiValuedList
          {...listProps}
          filter={filter}
          itemProps={{ height: TAG_HEIGHT.height28 }}
          items={items}
          moreProps={{ containerRef: scrollRef }}
          sortMoreItems={sortMoreItems}
        />
      ) : (
        <TableCellEmpty />
      )}
    </TableCellBase>
  )
}

export default TableServiceRequestCell
